const productRoutes = {
	productos: {
		path: '/productos',
		name: 'Productos',
		component: () => import('@/views/Productos.vue'),
		meta: { title: 'Productos' }
	},
	crearProducto: {
		path: '/producto',
		name: 'CrearProducto',
		component: () => import('@/views/Producto.vue'),
		meta: { title: 'Crear Producto' }
	},
	producto: {
		path: '/producto/:producto_id',
		name: 'EditarProducto',
		component: () => import('@/views/Producto.vue'),
		meta: { title: 'Editar Producto' }
	},
	collections: {
		path: '/colecciones',
		name: 'Colecciones',
		component: () => import('@/views/Colecciones.vue'),
		meta: { title: 'Colecciones' }
	},
	collectionDetail: {
		path: '/coleccion/:coleccion_id',
		name: 'Coleccion',
		component: () => import('@/views/Coleccion.vue'),
		meta: { title: 'Colección' }
	},
	proveedor: {
		path: '/proveedor',
		name: 'CrearProveedor',
		component: () => import('@/views/Proveedor.vue'),
		meta: { title: 'Crear Proveedor' }
	},
	fichasChidas: {
		path: '/fichas-chidas',
		name: 'FichasChidas',
		component: () => import('@/views/FichasChidas.vue'),
		meta: { title: 'Fichas Chidas' }
	},
	fichaChida: {
		path: '/ficha-chida/:id',
		name: 'FichaChida',
		component: () => import('@/views/FichaChida.vue'),
		meta: { title: 'Ficha Chida' }
	}
}

export default productRoutes
